import { useCallback } from "react";
import { useProduct } from "./store/product";
import { useAppStore } from "./store/app";
// import { __APP_SHADOW_ROOT } from ".";
import { Stack } from "@mui/material";
import SidebarLeft from "./components/SidebarLeft";
import SidebarRight from "./components/SidebarRight";
import SidebarTop from "./components/SidebarTop";
import SidebarBottom from "./components/SidebarBottom";
import Spinner from "./components/Spinner";
import { Toasts } from "./components/toast";
import { AppDrawer } from "./store/app-drawer";
import { AppDialog } from "./store/app-dialog";
import BottomSwipeableDrawer from "./store/app-swipable-drawer";
import CanvasTiles from "./components/CanvasTiles";
import SplashScreen from "./components/SplashScreen";
import Checkout from "./components/Checkout/Checkout";
// import { useCropper } from "./components/custom-cropper/cropper-store";
import CanvasTools from "./components/CanvasFab";
import CustomModal from "./components/CustomModal";

import CropperContainer from "@src/v3.0.0/components/Cropper/CropperContainer";
import CustomReactCropper from "@src/v3.0.0/components/Cropper/CustomReactCropper";
import CropperPresetManager from "@src/v3.0.0/components/Cropper/CropperPresetManager";
import { useCropperStore } from "./store/cropper/cropper-store";
import CanvasMediaBundler from "./components/CanvasMediaBundler";
import ProductPage from "./components/ProductPage";
import CanvasRulers from "./components/CanvasRulers";
import { Furnitures } from "./components/Furnitures/Furnitures";

const App = () => {
  const {product} = useProduct();
  const app = useAppStore();
  const cropper = useCropperStore(s => s.getCropper());

  /**
   * Changed ReactCropper event
   * @use app
   */
  const changed = useCallback((e) => {
    console.log('CHANGED', e.type);
    switch(e.type) {
      case 'destroy':
        console.log('%c destroy', 'background: lime');
        app.setIdle();
        break;
      case 'changed':
        console.log('%c changed', 'background: lime');
        app.setIdle();
        cropper.setCropperChanged();
        break;    
      case 'ready':
        console.log('%c ready', 'background: lime');
        app.setReady();
        cropper.setCropperReady();
        break;
      case 'replace':
        console.log('%c replace', 'background: lime');
        app.setIdle();
        break;    
      case 'error':
        console.log('%c error', 'background: lime');
        app.setIdle();
        break;    
      default:
        break;
    }
  }, [app, cropper]);

  if (!product) {
    return null;
  }

  return <>
    <ProductPage /> 
    <CanvasMediaBundler />
    <Checkout />
    <CropperPresetManager />
    <AppDrawer />
    <AppDialog />
    <BottomSwipeableDrawer />
    <CustomModal>
      <Spinner />
      <Stack direction={'column'} width={'100%'} height={'100%'} flexWrap={'wrap'}>
        {/* <Stack height={'100%'} flexWrap={'wrap'}> */}
        <SidebarLeft />
        {/* </Stack> */}
        <Stack
          width={'100%'}
          height={'100%'} 
          flexWrap={'wrap'}
        >
          <SidebarTop />
          <CropperContainer>
            <Toasts />
            <SplashScreen />
            <CanvasRulers />
            <CanvasTiles />
            <Furnitures />
            <CanvasTools />
            <CustomReactCropper 
              changed={changed}
              error={false}
              cropperConfig={{
                className: "cropper-container-root",
                gui: product.gui,
                initialAspectRatio: product.aspect,
                aspectRatio: product.aspect,
              }}
            />
          </CropperContainer>
          <SidebarBottom />
        </Stack>
        {/* <Stack height={'100%'} flexWrap={'wrap'}> */}
          <SidebarRight />
        {/* </Stack> */}
      </Stack>
    </CustomModal>
  </>
};

export default App;

// styled 10.0.27